import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListChannelMembershipsForAppInstanceUser } from "../schemas/schemas_0";
export { $Command };
export class ListChannelMembershipsForAppInstanceUserCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "ListChannelMembershipsForAppInstanceUser", {})
    .n("ChimeSDKMessagingClient", "ListChannelMembershipsForAppInstanceUserCommand")
    .sc(ListChannelMembershipsForAppInstanceUser)
    .build() {
}
